var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.656,
    height: 19,
    viewBox: "0 0 15.656 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M7.808,11.255a3.309,3.309,0,0,0,3.315-3.315A3.411,3.411,0,0,0,7.808,4.508,3.309,3.309,0,0,0,4.494,7.822,3.494,3.494,0,0,0,7.808,11.255Zm-5.564-9A7.868,7.868,0,1,1,13.372,13.386L7.808,18.95,2.245,13.386A8.083,8.083,0,0,1,2.245,2.258Z",
    transform: "translate(-0.025 0.05)",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/Place.dc3ba1633372663577fd7f2a5b64b065.svg";
export { ForwardRef as ReactComponent };